import { SVGProps, Ref, forwardRef } from 'react';

export const CloudOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5 2a6.5 6.5 0 0 1 6.145 8.614A6 6 0 0 1 18 22H6a6 6 0 0 1-2.941-11.23 5 5 0 0 1 5.905-5.677A6.5 6.5 0 0 1 14.5 2m0 1.8c-1.69 0-3.173.891-4.004 2.238L9.842 7.1l-1.223-.24Q8.316 6.8 8 6.8a3.2 3.2 0 0 0-3.162 3.695l.19 1.232-1.086.612A4.2 4.2 0 0 0 6 20.2h12a4.2 4.2 0 0 0 1.85-7.97l-1.422-.7.515-1.502A4.7 4.7 0 0 0 14.5 3.8"
            fill="currentColor"
        />
    </svg>
));
CloudOutlinedSize24Glyph.displayName = 'CloudOutlinedSize24Glyph';
